import React, { useState } from "react";
import Sidebar, { MobileTopBar } from "./Sidebar";
import { Toaster } from "sonner";
import { Eye } from "lucide-react";
import { useAuth } from "../lib/auth";

export default function Layout({ children }) {
  const { user } = useAuth();
  const isViewer = user?.role === "viewer";
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      <Sidebar mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />
      <main className="min-h-screen md:ml-[260px]">
        <MobileTopBar onOpenMenu={() => setMobileOpen(true)} />
        {isViewer && (
          <div data-testid="viewer-banner" className="sticky top-0 z-10 flex items-center gap-2 border-b border-amber-200 bg-amber-50 px-4 py-2 text-xs text-amber-900 md:px-6">
            <Eye size={12} />
            <span>You're signed in as a view-only user. Edits, creates, and deletions are disabled.</span>
          </div>
        )}
        <div className="mx-auto max-w-[1400px] px-4 py-6 sm:px-6 sm:py-8 md:px-10">{children}</div>
      </main>
      <Toaster richColors position="top-right" />
    </div>
  );
}
